import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { RaffleHistoryResponse } from "@/apps/raffle/types";

type RaffleHistoryState = {
  historyByYandexId: Record<string, RaffleHistoryResponse>;
  getHistory: (yandexId: string | null) => RaffleHistoryResponse | null;
  setHistory: (yandexId: string, history: RaffleHistoryResponse) => void;
  clearHistory: (yandexId: string) => void;
};

export const useRaffleHistoryStore = create<RaffleHistoryState>()(
  persist(
    (set, get) => ({
      historyByYandexId: {},
      getHistory: (yandexId) =>
        yandexId ? get().historyByYandexId[yandexId] ?? null : null,
      setHistory: (yandexId, history) =>
        set((state) => ({
          historyByYandexId: {
            ...state.historyByYandexId,
            [yandexId]: history,
          },
        })),
      clearHistory: (yandexId) =>
        set((state) => {
          const { [yandexId]: _removed, ...historyByYandexId } =
            state.historyByYandexId;

          return { historyByYandexId };
        }),
    }),
    {
      name: "raffle-history:store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        historyByYandexId: state.historyByYandexId,
      }),
    }
  )
);
